//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './HL7OutgoingMessageClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type SendMeasurementMessageHL7OutgoingMessageQueryParameters = {
  measurementId: number ;
}

export type SendDocumentMessageHL7OutgoingMessageQueryParameters = {
  documentId: string ;
}

export function sendPatientRequestMessageUrl(): string {
  let url_ = getBaseUrl() + "/api/hl7/out-messages/patient-request";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function sendPatientRequestMessageMutationKey(): MutationKey {
  return trimArrayEnd([
      'HL7OutgoingMessageClient',
      'sendPatientRequestMessage',
    ]);
}

/**
 * Sends a patient information request message
 */
export function useSendPatientRequestMessageMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.SendHL7PatientRequestDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.SendHL7PatientRequestDto, TContext> {
  const key = sendPatientRequestMessageMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.SendHL7PatientRequestDto) => Client.sendPatientRequestMessage(dto),
    mutationKey: key,
  });
}
  
export function sendMeasurementMessageUrl(measurementId: number): string {
  let url_ = getBaseUrl() + "/api/hl7/out-messages/measurement/{measurementId}";
if (measurementId === undefined || measurementId === null)
  throw new Error("The parameter 'measurementId' must be defined.");
url_ = url_.replace("{measurementId}", encodeURIComponent("" + measurementId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function sendMeasurementMessageMutationKey(measurementId: number): MutationKey {
  return trimArrayEnd([
      'HL7OutgoingMessageClient',
      'sendMeasurementMessage',
      measurementId as any,
    ]);
}

/**
 * Sends message regarding measurement
The measurement id.
Request parameter
 */
export function useSendMeasurementMessageMutation<TContext>(measurementId: number, options?: Omit<UseMutationOptions<void, unknown, Types.SendHL7MessageDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.SendHL7MessageDto, TContext> {
  const key = sendMeasurementMessageMutationKey(measurementId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.SendHL7MessageDto) => Client.sendMeasurementMessage(measurementId, dto),
    mutationKey: key,
  });
}
  
type SendMeasurementMessage__MutationParameters = SendMeasurementMessageHL7OutgoingMessageQueryParameters & {
  dto: Types.SendHL7MessageDto;
}

/**
 * Sends message regarding measurement
The measurement id.
Request parameter
 */
export function useSendMeasurementMessageMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, SendMeasurementMessage__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: SendMeasurementMessageHL7OutgoingMessageQueryParameters}): UseMutationResult<void, unknown, SendMeasurementMessage__MutationParameters, TContext> {
  const key = sendMeasurementMessageMutationKey(options?.parameters?.measurementId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: SendMeasurementMessage__MutationParameters) => Client.sendMeasurementMessage(data.measurementId ?? options?.parameters?.measurementId!, data.dto),
  mutationKey: key,
});
}
  
export function sendDocumentMessageUrl(documentId: string): string {
  let url_ = getBaseUrl() + "/api/hl7/out-messages/document/{documentId}";
if (documentId === undefined || documentId === null)
  throw new Error("The parameter 'documentId' must be defined.");
url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function sendDocumentMessageMutationKey(documentId: string): MutationKey {
  return trimArrayEnd([
      'HL7OutgoingMessageClient',
      'sendDocumentMessage',
      documentId as any,
    ]);
}

/**
 * Sends message regarding document
The document id.
Request parameter
 */
export function useSendDocumentMessageMutation<TContext>(documentId: string, options?: Omit<UseMutationOptions<void, unknown, Types.SendHL7MessageDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.SendHL7MessageDto, TContext> {
  const key = sendDocumentMessageMutationKey(documentId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.SendHL7MessageDto) => Client.sendDocumentMessage(documentId, dto),
    mutationKey: key,
  });
}
  
type SendDocumentMessage__MutationParameters = SendDocumentMessageHL7OutgoingMessageQueryParameters & {
  dto: Types.SendHL7MessageDto;
}

/**
 * Sends message regarding document
The document id.
Request parameter
 */
export function useSendDocumentMessageMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, SendDocumentMessage__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: SendDocumentMessageHL7OutgoingMessageQueryParameters}): UseMutationResult<void, unknown, SendDocumentMessage__MutationParameters, TContext> {
  const key = sendDocumentMessageMutationKey(options?.parameters?.documentId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: SendDocumentMessage__MutationParameters) => Client.sendDocumentMessage(data.documentId ?? options?.parameters?.documentId!, data.dto),
  mutationKey: key,
});
}